var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"temp"},[_c('div',{staticClass:"swiper-container dataScreen"},[_c('div',{staticClass:"swiper-wrapper"},[_c('div',{staticClass:"swiper-slide"},[_c('img',{attrs:{"src":require("@/assets/temp/p1c.png")}})]),_c('div',{staticClass:"swiper-slide"},[_c('img',{attrs:{"src":require("@/assets/temp/p2c.png")}})])])])])
}]

export { render, staticRenderFns }